import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { CreateCompanyFieldsType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const updateCompanyFieldsById = (
  payload: CreateCompanyFieldsType
): Promise<AxiosResponse<CreateCompanyFieldsType>> => {
  return axios.patch(`${baseURL}updateCompanyFieldsById`, payload);
};

export const deleteCompanyFieldsById = (
  id: string
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteCompanyFieldsById/${id}`);
};
